import About from "./about/About";
import ContactSection from "./contact/Contact";
import Hero from "./hero/hero"
import 'aos/dist/aos.css';

import AOS from 'aos';
import { useEffect } from "react";
import Services from "./services/Services";

import Gallery from "./gallery/Gallery";
import WhyChooseUs from "./whyUs/WhyUs";


const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Hero />
            <About />
            <Services />

            <Gallery />
            <WhyChooseUs />
            <ContactSection />
        </>

    )
}

export default Home;